import { supabase } from "@/integrations/supabase/client";

/** UI gate only: sensitive operations must also enforce roles on the server. */
export async function checkAdminAccess(): Promise<"signed-out" | "denied" | "authorized"> {
  try {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) return "signed-out";
    const { data: roles, error: roleError } = await supabase
      .from("user_roles")
      .select("role")
      .eq("user_id", data.user.id)
      .eq("role", "admin");
    return !roleError && roles?.some((row) => row.role === "admin") ? "authorized" : "denied";
  } catch {
    return "denied";
  }
}